module.exports = __webpack_public_path__ + "img/7s.1f7396c4.png";